import { Block, blockAlignmentOptions } from '@/components/block';
import { RawHtmlBlockProps } from '@/types/block-types';
import { tv } from '@/utils/styles';

// @TODO this is a very specific parser for the Scribe html
// In the future make more generic and handle other HTML scenarios
const parseRawScribeHtmlBody = (htmlString: string | TrustedHTML | undefined) => {
  if (!htmlString) return '';
  const htmlAsString = htmlString.toString();

  // Uses regex to find <p> tags and their contents
  const paragraphRegex = /<p[^>]*>([\s\S]*?)<\/p>/gi;

  const processedHtml = htmlAsString.replace(paragraphRegex, (match, paragraphContent) => {
    // Look for text that starts with a number followed by a dot and space
    const stepNumberRegex = /^(\d+)\.\s(.*)/;

    if (stepNumberRegex.test(paragraphContent)) {
      // Replace the number with a wrapped version, removing the trailing dot
      const newContent = paragraphContent.replace(stepNumberRegex, '<span class="scribe-step-number">$1</span> $2');

      return match.replace(paragraphContent, newContent);
    }

    return match;
  });

  return processedHtml;
};

const RawHtmlBlock = ({
  id,
  heading,
  body,
  blockAlignment = 'left',
  noTopPadding = false,
  bodyClasses,
  className,
  variant,
  ...props
}: RawHtmlBlockProps) => {
  const parsedBody = parseRawScribeHtmlBody(body);

  const { base, block, grid, rawHtml } = styles({ variant });

  return (
    <div className={base()}>
      <Block
        id={id}
        heading={heading}
        blockAlignment={blockAlignment}
        noTopPadding={noTopPadding}
        className={block({ className })}
        {...props}
      >
        <div
          style={{
            alignItems: blockAlignmentOptions[blockAlignment],
            textAlign: blockAlignment,
          }}
          className={grid()}
        >
          {body && (
            <div
              className={rawHtml({ className: bodyClasses || '' })}
              dangerouslySetInnerHTML={{ __html: parsedBody }}
            />
          )}
        </div>
      </Block>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'text-text-primary',
    headingWrapper: 'mb-12',
    linksWrapper: 'max-w-5xl',
    block: null,
    grid: null,
    rawHtml: '',
  },
  variants: {
    variant: {
      light: {
        base: 'bg-white',
      },
      grey: {
        base: 'bg-grey-50',
      },
      dark: {
        base: 'bg-blue-900',
      },
    },
  },
});

export { RawHtmlBlock };
